import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { Field, Formik, FieldProps, FormikProps } from 'formik';

import { StyledForm, Button, StyledFormGroup } from '../../components';
import { formatFormValues, formatGqlError, getLoggedInUser, getUserRoles } from '../../utils/helpers';
import Span from '../../typography/Span';
import StyledFormSelect from '../../components/formElements/StyledFormSelect';
import * as Yup from 'yup';
import { MutationFn } from 'react-apollo';
import { ApolloError } from 'apollo-client';

const InviteUserValidation = Yup.object().shape({
  email: Yup.string()
    .email()
    .required('Required'),
  role: Yup.mixed().required('Required'),
});

interface InviteUserFormValues {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
}

type AdminFormProps = RouteComponentProps & {
  mutation: MutationFn;
  error?: ApolloError;
  loading: boolean;
};

const InviteUserForm: React.FC<AdminFormProps> = ({ mutation, error, loading }) => {
  const user = getLoggedInUser();

  return (
    <Formik
      validationSchema={InviteUserValidation}
      initialValues={{
        email: '',
        role: '',
        firstName: '',
        lastName: '',
      }}
      onSubmit={(values: InviteUserFormValues) => {
        const formattedValues = formatFormValues(values);
        mutation({
          variables: formattedValues,
        });
      }}
      render={(formikProps: FormikProps<InviteUserFormValues>) => {
        return (
          <StyledForm maxWidth="350px">
            <Field
              name="firstName"
              render={({ field }: FieldProps<InviteUserFormValues>) => (
                <StyledFormGroup {...field} field={field} form={formikProps} label="First Name" />
              )}
            />
            <Field
              name="lastName"
              render={({ field }: FieldProps<InviteUserFormValues>) => (
                <StyledFormGroup {...field} field={field} form={formikProps} label="Last Name" />
              )}
            />
            <Field
              name="email"
              render={({ field }: FieldProps<InviteUserFormValues>) => (
                <StyledFormGroup {...field} field={field} form={formikProps} label="Email" />
              )}
            />
            <Field
              name="role"
              render={({ field }: FieldProps<InviteUserFormValues>) => (
                <StyledFormSelect
                  width="100%"
                  {...field}
                  field={field}
                  label="Role"
                  form={formikProps}
                  options={getUserRoles(user)}
                />
              )}
            />
            {error && (
              <Span width="100%" textAlign="center" color="error" mb={3}>
                {formatGqlError(error)}
              </Span>
            )}
            <Button isLoading={loading} type="submit" mt={2} text="Save & Update" />
          </StyledForm>
        );
      }}
    />
  );
};

export default withRouter(InviteUserForm);



// WEBPACK FOOTER //
// ./src/forms/admin/InviteUserForm.tsx